
const addClasses = (column, columnNumber) => {
  const classes = ["voyage__unorthodox-grid-item--low-img", "voyage__unorthodox-grid-item--tall-img"]



Array.prototype.forEach.call(column.children,(child, index) => { 
    const isUnevenColumn = columnNumber % 2 === 1
    if (isUnevenColumn) child.classList.add(classes[index % 2])
    else child.classList.add(classes[(index + 1) % 2])
  })
}

export default function handleUnorthodoxGridItems() {
  try{
  const unorthodoxGridColumn1 = document.querySelector("[data-unorthodox-grid-col-1]")
  const unorthodoxGridColumn2 = document.querySelector("[data-unorthodox-grid-col-2]")

  addClasses(unorthodoxGridColumn1, 1)
  addClasses(unorthodoxGridColumn2, 2)
  }
  catch(error){
  }
}